import { useContext, useEffect, useState } from "react";
import { StyleContext } from "../providers/StyleContextProvider";
import { useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet-async";
import { NewHeader } from "../components/Shared/NewHeader";

interface BlogMeta {    
    title: string;
    description: string;
    keywords: string;
    author: string;
    robots: string;
    ogTitle: string;
    ogDescription: string;
    ogUrl: string;
    ogType: string;
    ogImage?: string;
    twitterCard: string;
    twitterTitle: string;
    twitterDescription: string;
    twitterImage: string;    
}

const CLOUD_FRONT_URL = "https://d3awnpsg7u12yu.cloudfront.net";

export const BlogPage = () => {
    const styleContext = useContext(StyleContext);
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("blogPage"));
    const { slug } = useParams<{ slug: string }>();
    const [content, setContent] = useState<string | null>(null);
    const [meta, setMeta] = useState<BlogMeta | null>(null);
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    
    useEffect(() => {
        setStyles(styleContext.getComponentStyle("blogPage"));    
    }, [isMobile]);

    useEffect(() => {        
        fetch(`${CLOUD_FRONT_URL}/${slug}.html`)
        .then((res) => res.text())
        .then((data) => setContent(data))
        .catch(() => setContent("<h2>Blog not found</h2>"));

        fetch(`${CLOUD_FRONT_URL}/${slug}.json`)
        .then((res) => res.json())
        .then((data) => setMeta(data))
        .catch(() => setMeta(null));
    }, [slug]);

    if (!content) return <h2>Loading...</h2>;

    return (
        <div>
            {meta && (
                <Helmet>
                    <title>{meta.title}</title>
                    <meta name="description" content={meta.description} />
                    <meta name="keywords" content={meta.keywords} />
                    <meta name="author" content={meta.author} />
                    <meta name="robots" content={meta.robots} />
                    <meta property="og:title" content={meta.ogTitle} />
                    <meta property="og:description" content={meta.ogDescription} />
                    <meta property="og:url" content={meta.ogUrl} />
                    <meta property="og:type" content={meta.ogType} />
                    {meta.ogImage && <meta property="og:image" content={meta.ogImage} />}
                    <meta name="twitter:card" content={meta.twitterCard} />
                    <meta name="twitter:title" content={meta.twitterTitle} />
                    <meta name="twitter:description" content={meta.twitterDescription} />
                    {meta.twitterImage && <meta name="twitter:image" content={meta.twitterImage} />}                    
                </Helmet>
            )}
            <NewHeader />
            <div dangerouslySetInnerHTML={{ __html: content }} style={styles.container} />
        </div>
    );
};